import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VaSellingInfoComponent } from './selling-info.component';
import { MatIconModule } from '@angular/material/icon';
import { VaSanitizePipe } from '@vendasta/uikit';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

@NgModule({
  imports: [CommonModule, MatIconModule, VaSanitizePipe, GalaxyPipesModule],
  declarations: [VaSellingInfoComponent],
  exports: [VaSellingInfoComponent],
})
export class VaSellingInfoModule {}
